import * as a from '@mitranim/js/all.mjs'
import * as um from './util-misc.mjs'

// Nop dummy for SSR.
export class Sib extends um.Ctxed {
  track() {}
  identify() {}
  trackLink() {}
  page() {}
}

export class ClientSib extends Sib {
  track(event, person, data) {this.call(`track`, event, personToSib(person), data)}
  identify(...src) {this.call(`identify`, ...src)}
  trackLink(...src) {this.call(`trackLink`, ...src)}
  page(...src) {this.call(`page`, ...src)}

  call(name, ...args) {
    a.reqValidStr(name)

    const sib = window.sib
    if (!a.isComp(sib)) return

    const fun = sib[name]
    if (a.isFun(fun)) {
      fun.apply(sib, args)
      return
    }

    const que = a.optArr(sib.equeue)
    if (!que) return

    // Precaution against infinite memory leaks when SIB stuff is missing or
    // broken, for example due to adblockers.
    if (que.length > 1024) return

    que.push({[name]: args})
  }
}

function personToSib(person) {
  return !a.optStruct(person) ? null : {
    name: person.name,
    id: person.id,
    location : person.geoName,
    hasPaidListing : person.hasPaidListing(),
  }
}
